import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cd-fake-link',
  templateUrl: './cd-fake-link.component.html',
  styleUrls: ['./cd-fake-link.component.scss'],
})
export class CdFakeLinkComponent implements OnInit {
  @Input() text = 'N/A';
  @Output() callBack = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  onClick() {
    this.callBack.emit();
  }
}
